import { get } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { ThemeProvider } from "styled-components";

export default function ReportTheme({ theme: _theme, children }) {
  const theme = _theme || window.theme;
  const primaryColor = `#${get(theme, "colors.primary")}`;
  const secondaryColor = `#${get(theme, "colors.secondary")}`;

  return (
    <ThemeProvider
      theme={{
        live: {
          colors: {
            primary: primaryColor,
            secondary: secondaryColor
          }
        }
      }}>
      {children}
    </ThemeProvider>
  );
}

ReportTheme.propTypes = {
  theme: PropTypes.shape({
    colors: PropTypes.shape({
      primary: PropTypes.string,
      secondary: PropTypes.string
    })
  })
};
